import React, { Component } from 'react';
import styles from './SelectGroup.module.scss';
import classNames from 'classnames/bind';

import {Select} from '../../molecules';
import {InputGuide, LabelText} from '../../atoms';

const cx = classNames.bind(styles);

class SelectGroup extends Component {

  render() {
    const { selectName, labelText, isError, value, onChange, onBlur, options, inputGuideText, defaultHideGuide, className } = this.props;
    return (
      <div className={`${cx('SelectGroup')} ${className}`}>
        <LabelText className={cx('SelectGroup__label')} text={labelText} />
        <Select
            isError={isError}
            name={selectName}
            value={value}
            options={options}
            onChange={onChange}
            onBlur={onBlur}
            className={cx('RegisterForm__two-columns-column')}
          />
        <InputGuide className={cx('SelectGroup__input-guide')} text={inputGuideText} isError={isError} defaultHide={defaultHideGuide} />
      </div>
    );
  }
}

export default SelectGroup;
